export const mod_15 = [...Array(15).keys()];
